import { Button, Grid, Typography } from "@material-ui/core";
import { FieldError, UseFormMethods } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PublishRoundedIcon from "@material-ui/icons/PublishRounded";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useState } from "react";

interface IUploadFileProps {
    control: UseFormMethods["control"];
    prefix?: string;
    error: FieldError | undefined;
    disabled?: boolean;
    name: string;
    buttonText: string;
    preventCentering?: boolean;
}

const UploadFileButton = (props: IUploadFileProps) => {
    const { t } = useTranslation(["validation"]);
    const { control, error, prefix, disabled, name, buttonText, preventCentering } = props;
    const namePrefix = prefix ? `${prefix}.` : "";
    const acceptableFileTypes: string[] = ["jpg", "jpeg", "png", "gif", "bmp", "pdf"];
    const [, setFileName] = useState<string>("");

    const toBase64 = (file: any) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    const handleFileSelect = async (event: any) => {
        if (event.target.value) {
            const fileExtension = event.target.files[0].name.split(".").pop().toLowerCase();
            if (acceptableFileTypes.includes(fileExtension)) {
                const fileb64Value = await toBase64(event.target.files[0]);
                const fileValueToSubmit = `${event.target.files[0].name};`.concat(fileb64Value as string);
                control.setValue(`${namePrefix}${name}`, fileValueToSubmit);
                control.trigger(`${namePrefix}${name}`);
                setFileName(Math.random().toString()); // to force component rerender whatever the file selected
            } else console.log("Wrong file type, ext: " + fileExtension);
            (document.getElementById(`${namePrefix}${name}`) as any).value = "";
        }
    };

    return (
        <>
            <input
                type="text"
                name={`${namePrefix}${name}`}
                ref={control.register({ required: t("validation:required") })}
                style={{ display: "none" }}
            />
            <input
                accept="image/jpeg,image/png,application/pdf"
                style={{ display: "none" }}
                id={`${namePrefix}${name}`}
                type="file"
                onChange={handleFileSelect}
            />
            <label htmlFor={`${namePrefix}${name}`}>
                <Grid container item spacing={1} direction="column">
                    {/* <Grid
                        container
                        item
                        spacing={1}
                        alignItems={preventCentering ? undefined : "center"}
                        justify={preventCentering ? undefined : "center"}
                        direction="column"
                    > */}
                    <Grid
                        container
                        item
                        spacing={1}
                        alignItems={"center"}
                        justify={preventCentering ? undefined : "center"}
                        direction="row"
                    >
                        <Grid item>
                            <Button
                                variant="contained"
                                color="secondary"
                                component="span"
                                disabled={disabled}
                                startIcon={<PublishRoundedIcon />}
                            >
                                {buttonText}
                            </Button>
                        </Grid>
                        <Grid item>
                            {control.getValues(`${namePrefix}${name}`) ? (
                                <CheckCircleIcon style={{ color: "green" }} />
                            ) : (
                                <CheckCircleOutlineIcon />
                            )}
                        </Grid>
                    </Grid>
                    {error && (
                        <Grid item>
                            <Typography color="error" variant="body2">
                                {error.message}
                            </Typography>
                        </Grid>
                    )}
                    <Grid item>
                        <Typography variant="body2">{t("validation:allowedFileTypes")}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2" style={{ maxWidth: preventCentering ? undefined : "250px" }}>
                            {control.getValues(`${namePrefix}${name}`)?.split(";")[0]}
                        </Typography>
                    </Grid>

                    {/* </Grid> */}
                </Grid>
            </label>
        </>
    );
};

export default UploadFileButton;
